import { Body1, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICompareFlightOnboardingContentProps {
  onAboutComparisonClick(): void;
}

export function CompareFlightOnboardingContent({ onAboutComparisonClick }: ICompareFlightOnboardingContentProps) {
  return (
    <div className={styles['container']}>
      <Body1 color="text-inverted-default" whiteSpace="nowrap">
        Теперь ЖК можно сравнивать:
        <br />
        жмите плюс — соберём таблицу
        <br />с выводами в разделе «Сравнение»
      </Body1>

      <Button theme="inverted" size="XS" maxWidth={138} onClick={onAboutComparisonClick}>
        О сравнении ЖК
      </Button>
    </div>
  );
}
